import { toast as sonnerToast } from 'sonner';
export function toast({ type = 'info', title, description }) {
    const message = title ?? description ?? '';
    (sonnerToast[type] ?? sonnerToast)(message);
}
